import { createFileRoute, useSearch } from "@tanstack/react-router";
import { useEffect } from "react";

import { HStack } from "@/components/Layout";

import { AddCertificationStepKeys } from "../-constants/constant";
import { CERTIFICATION_KIND_STEPS } from "../-constants/steps";
import useCertificationKindParam from "../-hooks/useCertificationKind";
import { getCertificationFormStoreContext } from "../-store/certificationFormStoreContext";
import { CertificationKind } from "../../-constants";

import InnerNavigation from "./-components/InnerNavigation";
import ManualForm from "./-components/ManualForm";
import { ProgressCard } from "./-components/ProgressCard";

export const Route = createFileRoute(
  "/_staff/certification/add/$certificationKind/",
)({
  component: () => <Form />,
});

function Form() {
  const { certificationKind } = useCertificationKindParam();
  const { context } = getCertificationFormStoreContext(certificationKind);
  const store = context.createStore();
  const steps = CERTIFICATION_KIND_STEPS[certificationKind];

  // QueryParameterにIDが設定されている場合は、初期値として設定する
  const formStore = store.getState();
  const search = useSearch({ strict: false }) as {
    baseCertificationId?: string;
    specialtyCertificationId?: string;
  };

  useEffect(() => {
    if (search.baseCertificationId) {
      if (certificationKind === CertificationKind.SPECIALTY) {
        formStore.actions.setData({
          step: AddCertificationStepKeys.SPECIALTY_RELATED_BASIC_CERTIFICATION,
          data: { baseCertificationIds: [search.baseCertificationId] },
        });
      }
      if (certificationKind === CertificationKind.HANDLING) {
        formStore.actions.setData({
          step: AddCertificationStepKeys.HANDLING_RELATED_BASIC_AND_SPECIALTY_CERTIFICATION,
          data: { baseCertificationIds: [search.baseCertificationId] },
        });
      }
    }
    if (
      search.specialtyCertificationId &&
      certificationKind === CertificationKind.HANDLING
    ) {
      formStore.actions.setData({
        step: AddCertificationStepKeys.HANDLING_RELATED_BASIC_AND_SPECIALTY_CERTIFICATION,
        data: { specialtyCertificationIds: [search.specialtyCertificationId] },
      });
    }
  }, [search, formStore.actions, certificationKind]);

  return (
    <context.Provider value={store}>
      <HStack className="w-full p-6 gap-6">
        <div className="shrink-0">
          <InnerNavigation steps={steps.map((step) => step.step)} />
        </div>
        <ManualForm className="grow min-w-[340px]" steps={steps} />
        <div className="shrink-0">
          <ProgressCard steps={steps.map((step) => step.step)} />
        </div>
      </HStack>
    </context.Provider>
  );
}
